__turbopack_context__.v({
  "accordionChild": "twoColumnLayoutLP-module-scss-module__2ZWn7a__accordionChild",
  "accordionChildItem": "twoColumnLayoutLP-module-scss-module__2ZWn7a__accordionChildItem",
  "cardGrid": "twoColumnLayoutLP-module-scss-module__2ZWn7a__cardGrid",
  "cardGridItem": "twoColumnLayoutLP-module-scss-module__2ZWn7a__cardGridItem",
  "sectionTitle": "twoColumnLayoutLP-module-scss-module__2ZWn7a__sectionTitle",
});
